module.exports = __webpack_public_path__ + "static/media/img_plus.901cfbd4.jpeg";